export default defineAppConfig({
  icon: {},
  ui: {
    icons: {
      light: 'i-ph-sun',
      dark: 'i-ph-moon',
      system: 'i-ph-desktop',
    },
    colors: {
      primary: 'primary',
      secondary: 'secondary',
      tertiary: 'tertiary',
      neutral: 'neutral',
      success: 'primary',
      info: 'tertiary',
      warning: 'warning',
      error: 'error',
    },
    card: {
      slots: {
        root: 'rounded-[var(--ui-radius)] overflow-hidden',
      },
    },
  },
})
